
  import {Component, Prop, Vue} from "vue-property-decorator";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";

  @Component({
    name: "DeviceStatusItem",
  })
  export default class extends Vue {
    @Prop() readonly item: deviceItem;

    public checkactionerror(item): boolean {
      if (item.status == "true") {
        return false;
      } else if (item.status == "false") {
        return true;
      } else if (item.status == "default") {
        return false;
      }
    }

    public checkactionsuccess(item): boolean {
      if (item.status == "true") {
        return true;
      } else if (item.status == "false") {
        return false;
      } else if (item.status == "default") {
        return false;
      }
    }

    public checkactiondefult(item): boolean {
      if (item.status == "true") {
        return false;
      } else if (item.status == "false") {
        return false;
      } else if (item.status == "default") {
        return true;
      }
    }
  }
